export default "__VITE_ASSET__CoRv3bxJ__"